import { render, staticRenderFns } from "./InternalMessage.vue?vue&type=template&id=03d6c5f1&"
import script from "./InternalMessage.vue?vue&type=script&lang=js&"
export * from "./InternalMessage.vue?vue&type=script&lang=js&"
import style0 from "./InternalMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports